import { enableProdMode } from '@angular/core';
import { loadAppConfig } from './app/shared/app-config';

loadAppConfig()
  .then(async (config) => {
    if (config.production) {
      enableProdMode();
    }
    const { platformBrowserDynamic } = await import('@angular/platform-browser-dynamic');
    const { AppModule } = await import('./app/app.module');
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
